import { Flex, Space } from 'antd';
import capitalize from 'lodash/capitalize';
import { FC } from 'react';
import { useParams } from 'react-router-dom';

import { useAdminCompanyController_findOneById } from '@api-client/generated/AdminCompanyController/findOneById';
import { IconLogout } from '@assets';
import { useAccount } from '@hooks';

import * as S from './styled';

const Header: FC = () => {
  const { companyId } = useParams();

  const { data: company } = useAdminCompanyController_findOneById({
    params: {
      id: companyId!,
    },
    config: {
      enabled: !!companyId,
    },
  });

  const { account, signOut } = useAccount();

  return (
    <S.Header>
      <Flex gap={32}>
        {company ? (
          <Flex vertical gap={2}>
            <Space size={8}>
              <S.Text>You now working with:</S.Text>
              <S.CompanyName>{company?.name}</S.CompanyName>
              <S.CompanyName>{company?.details?.address?.countryCode}</S.CompanyName>
              <S.CompanyName>
                {company?.status ? `(${capitalize(company.status.split('_').join(' '))})` : ''}
              </S.CompanyName>
            </Space>
            <S.DebugText>
              company id: {company.id}; BOB50 ID: {company.bobReferenceId || '—'}
            </S.DebugText>
          </Flex>
        ) : (
          <div />
        )}
      </Flex>

      <Flex gap={80}>
        <Space size={8}>
          <S.UserName>{account?.email}</S.UserName>
        </Space>
        {/* signOut ends the realm session, which navigates away on its own. */}
        <S.Logout type="text" aria-label="Log out" onClick={signOut}>
          <IconLogout />
        </S.Logout>
      </Flex>
    </S.Header>
  );
};

export default Header;
